import type { AsyncBelongsTo } from '@ember-data/model';
import Model, { attr, belongsTo } from '@ember-data/model';
import type Location from 'garaje/models/location';
import { squareFeetToSquareInches, squareInchesToSquareFeet } from 'garaje/utils/area-conversions';

export default class WorkplaceUtilizationDetail extends Model {
  @belongsTo('location', { async: true, inverse: null }) declare location: AsyncBelongsTo<Location>;

  @attr('number') declare area?: number | null;
  @attr('currency') declare monthlyRent: number | null;
  @attr('string') declare monthlyRentCurrencyCode: string | null;
  @attr('date') declare leaseExpirationDate: Date | null;

  get areaSqFt(): number | null {
    if (!this.area) return null;
    return squareInchesToSquareFeet(this.area);
  }
  set areaSqFt(value: string) {
    const area = parseFloat(value);
    if (isNaN(area)) {
      this.area = null;
      return;
    }
    this.area = squareFeetToSquareInches(area);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'workplace-utilization-detail': WorkplaceUtilizationDetail;
  }
}
